import React from "react";
import {
  RECAP_EVENT_FIELD,
} from "../../../constants";

const SingleRecapFeedback = (props) => {
  const { data, onChange, disabled = false } = props;

  const handleChange = (field, value) => {
    onChange(field, value);
  };

  return (
    <div>
      <label className="bold-label">feedback:</label>
      <textarea
        rows="6"
        className="form-control w-100"
        onChange={(e) =>
          handleChange(RECAP_EVENT_FIELD.FEEDBACK, e.target.value)
        }
        value={data.feedback}
        disabled={disabled}
      />
      {data?.errors?.feedback && (
        <div className="invalid-field-error d-block">
          {data.errors.feedback}
        </div>
      )}
    </div>
  );
};

export default SingleRecapFeedback;
